import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutEdiTenderErrors extends Layout {
	sourceEdiMapError: DataSource;
	tableError: Table;
}
